module.exports = __webpack_public_path__ + "static/img/case_detail_02_4.b50d424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_4.png
// module id = PCsH
// module chunks = 34